import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-status-info-controller',
  templateUrl: './status-info-controller.component.html',
  styleUrls: ['./status-info-controller.component.css']
})
export class StatusInfoControllerComponent implements OnInit {

  assetStatusList: any = [];
  assetStatusFilter: any = [];
  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading: any = false
  id: any

  addForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  updateForm: any | FormGroup
  isEdit: boolean = false
  assetStatusData: any = [];

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";

  constructor(
    private generic_service: GenericService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.addForm = this.fb.group({
      statusDescription: [],
      name: ['',[Validators.required]]
    })
    this.updateForm = this.fb.group({
      statusDescription: [],
      name: ['',[Validators.required]]
    })
    this.getAllAssetStatus();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page+1;
  }

  getAllAssetStatus(){
    this.isLoading = true
    this.generic_service.getAllAssetStatus().subscribe(
      (res:any)=> {
        console.log(res)
        this.assetStatusList = res.response
        this.assetStatusFilter = res.response
        this.totalRecords = res.response.length
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  isDisabled(statusName: string): boolean {
    return statusName === 'under repair' || statusName === 'installed/deployed';
  }

  getAssetStatusById(assetStatusId:any){
    this.generic_service.getAssetStatusById(assetStatusId).subscribe(
      (response:any)=>{
        this.assetStatusData = []
        this.assetStatusData.push(response.response)
        this.updateForm.patchValue({
          statusDescription: response.response.statusDescription,
          name: response.response.name
        })
        this.isEdit = true
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalAdd")?.click()
    document.getElementById("closeModalUpdate")?.click()
    document.getElementById("closeModalDelete")?.click()
  }

  deleteAssetStatus(){
    this.generic_service.deleteAssetStatus(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllAssetStatus();
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any,list: any){
    this.id = id
    this.recordId = list.assetStatusId
    this.recordName = list.name
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }


  refreshAll(){
    this.pageNumber = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllAssetStatus()
  }

  // getAllAssetDepreciationMethodByWildSearch(){
  //   console.log(this.searchFilter)
  //   if(this.searchFilter == "" || this.searchFilter == null){
  //     return
  //   }
  //   this.generic_service.getAllAssetDepreciationMethodByWildSearch(this.searchFilter).subscribe(
  //     (res: any) => {
  //       if(res.response == null || res.response.length == 0 || res.response == undefined){
  //       this.assetDepreciationDataList = []
  //       this.totalRecords = 0
  //         return

  //       }
  //       this.assetDepreciationDataList = res.response
  //       this.totalRecords = res.response.length
  //     },
  //     (err: any) => {
  //       console.log(err);
  //     }
  //   );
  // }


  addAssetStatus(){

    if(this.formSubmit){
      return
    }
    if(!this.addForm.valid){
      this.toastr.error("Please fill in all required fields");
      this.formSubmit = false;
      return
    }

    this.formSubmit = true;


    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": this.addForm.get('name').value,
      "canBeDeleted": false,
      "statusDescription": this.addForm.get('statusDescription').value,
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.addAssetStatus(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.addForm.reset()
        this.cancelModel()
        this.getAllAssetStatus();

        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.formSubmit = false;
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  updateAssetStatus(){
    this.formSubmit = true;
    if(!this.updateForm.valid){
      this.toastr.error("Please fill in all required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "canBeDeleted": false,
      "id": this.assetStatusData[0].id,
      "assetStatusId": this.assetStatusData[0].assetStatusId,
      "name": this.updateForm.get('name').value,
      "statusDescription": this.updateForm.get('statusDescription').value,
      "cid": Number(this.cid)

    }
    console.log(body)
    this.generic_service.updateAssetStatus(body).subscribe(
      (response:any)=>{
        this.isEdit = false
        this.getAllAssetStatus();
        this.cancelModel()
        this.formSubmit = false;
        this.updateForm.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }



  searchByName(): void {
    const searchValue = this.searchFilter.trim().toLowerCase();

    if (searchValue) {
      this.assetStatusList = this.assetStatusFilter.filter((status: any) =>
        status.name?.toLowerCase().includes(searchValue)
      );

        this.totalRecords = this.assetStatusList.length;
        this.pageNumber = 1
        this.first = 0
    } else {
      // create a new array reference
      this.assetStatusList = [...this.assetStatusFilter];
      this.totalRecords = this.assetStatusList.length;
      this.pageNumber = 1
      this.first = 0

    }
  }


}